<template>
	<div
		id="industry-detail"
		:class="[!isWeb ? 'mobile-industry-detail' : '', !isWeb && isSafari ? 'safari' : '']"
	>
		<div class="detail-title">
			<div class="detail-title__icon" @click="goToIndustries()">
				<SidebarArrow :border="'#0047ff'" />
			</div>
			<h1 class="detail-title__text">
				{{ !$route.query.id ? 'Detalhes da Indústria' : 'Editar Indústria' }}
			</h1>
		</div>
		<IndustryForm :isWeb="isWeb" />
	</div>
</template>

<script>
import SidebarArrow from '@/components/shared/Icons/SidebarArrow.vue';
import IndustryForm from '@/components/modules/Industry/IndustryDetail/IndustryForm/IndustryForm.vue';

export default {
	name: 'IndustryDetail',
	components: { SidebarArrow, IndustryForm },
	data: () => ({
		windowWidth: window.innerWidth,
	}),
	created() {},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize);
		});
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	},
	methods: {
		onResize() {
			this.windowWidth = window.innerWidth;
		},
		goToIndustries() {
			this.$router.push({ path: '/dashboard/config/industryType' });
		},
	},
	computed: {
		isWeb() {
			return this.windowWidth > 992;
		},
		isSafari() {
			return navigator.vendor == 'Apple Computer, Inc.';
		},
	},
};
</script>

<style lang="scss">
@import 'IndustryDetail.scss';
</style>
